import { render } from "./InvoiceModal.vue?vue&type=template&id=d39687b8"
import script from "./InvoiceModal.vue?vue&type=script&lang=ts"
export * from "./InvoiceModal.vue?vue&type=script&lang=ts"
script.render = render

export default script